import React from 'react';

const ListOfSectionMenu = ({ module, sections = [], onNavigateSection }) => {
    const navigateSection = (sectionNo) => {
        if (typeof onNavigateSection === 'function') onNavigateSection(sectionNo);
    };
    return (
        <>
            <div className="ds-module-menu__title cp">
                <div className="df aic">
                    <img style={{ width: '16px', height: '16px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/list.png')} alt="list-of-sections" />
                    <span>List of Sections</span>
                </div>
                <img style={{ height: '10px', marginRight: '8px' }} src={require('../../../images/dashboard/icons/arrow.png')} alt="arrow-right" />
            </div>
            <div className="ds-module-menu__divider" />
            <div className="ds-module-menu__sub">
                <span className="tooltip-area">
                    {sections.length > 0 &&
                        <span className={`tooltip-area ${(module?.heading === "Investor Match" || (sections.length && sections.length < 8))
                            ? 'tooltip-top-important'
                            : ''
                            }`}
                        >
                            {sections.map((section, idx) => {
                                if (!section.stats) section.stats = module['sections'][0]['stats'];
                                const completeness = section.stats.completionPercent;

                                let riskColour;
                                if (module.type === "repository" || section.stats.riskPercent < 38) riskColour = 7;
                                else if (section.stats.riskPercent > 62) riskColour = 9;
                                else riskColour = 8;

                                let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";

                                let colorChange = false;
                                if (module['type'] == "warranty-disclosure") {
                                    if (section?.questions && section?.questions.length > 0) section?.questions.map(question => {
                                        if (question['answer']['radioOption'] == 'Disclosure' || question['answer']['radioOption'] == 'Not Sure') {
                                            colorChange = true;
                                            return;
                                        }
                                    })
                                }
                                return (
                                    <button
                                        key={idx}
                                        onClick={() => navigateSection(section['sectionNo'])}
                                        style={{ background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)` }}
                                        data-scroll-to={section['sectionNo']}
                                        className="overlay-box tal w100 tac cp c3-hover"
                                    >
                                        <span>{section['sectionName']}</span>
                                    </button>
                                );
                            })}
                        </span>
                    }
                </span>
            </div>
        </>
    );
};

export default ListOfSectionMenu;
